import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/sgrishchenko/reselect-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <h2 {...{
      "id": "motivation"
    }}>{`Motivation`}</h2>
    <p>{`Such projects as `}<a parentName="p" {...{
        "href": "https://github.com/reduxjs/reselect"
      }}>{`Reselect`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/toomuchdesign/re-reselect"
      }}>{`Re-reselect`}</a>{` try to solve the task of memoization. But there is no standard solutions for some applied problems. This library was created to try to systematically solve the following problems:`}</p>
    <ul>
      <li parentName="ul">{`Work with optional objects as a source for selection.`}</li>
      <li parentName="ul">{`Binding parametric selectors to specific property values.`}</li>
      <li parentName="ul">{`Adaptation of parametric selectors to the new parameter interface (useful for creating parametric `}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/reselect#createstructuredselectorinputselectors-selectorcreator--createselector"
        }}>{`structured selectors`}</a>{`).`}</li>
      <li parentName="ul">{`Using selection results as parameters for a new selection.`}</li>
      <li parentName="ul">{`Calculating an aggregate value from a collection of selector results.`}</li>
      <li parentName="ul">{`Structuring of selection results (more proper typed version of `}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/reselect#createstructuredselectorinputselectors-selectorcreator--createselector"
        }}>{`structured selector`}</a>{` and `}<a parentName="li" {...{
          "href": "https://github.com/toomuchdesign/re-reselect#createStructuredCachedSelector"
        }}>{`cached structured selector`}</a>{`).`}</li>
      <li parentName="ul">{`Implementation of key selectors composition (useful for `}<a parentName="li" {...{
          "href": "https://github.com/toomuchdesign/re-reselect#keyselectorcreator"
        }}>{`key selector creator`}</a>{` usages).`}</li>
    </ul>
    <h2 {...{
      "id": "principles"
    }}>{`Principles`}</h2>
    <h3 {...{
      "id": "dev-tool-integration"
    }}>{`Dev Tool Integration`}</h3>
    <p>{`All utility selectors should be displayed in `}<a parentName="p" {...{
        "href": "https://github.com/skortchmark9/reselect-tools"
      }}>{`dev tools`}</a>{` adequately. This is necessary to understand how the selector is related.`}</p>
    <h3 {...{
      "id": "dependency-support"
    }}>{`Dependency Support`}</h3>
    <p>{`All selectors must describe their dependencies correctly.`}</p>
    <h3 {...{
      "id": "typescript-support"
    }}>{`TypeScript Support`}</h3>
    <p>{`This library is written in `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/"
      }}>{`TypeScript`}</a>{` and initially focused on static type checking. All utility selectors are typed and tested at compile time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      